/** Returns the midpoint of two 'YYYY-MM-DDTHH:mm' datetimes in the same format. */
export function meanDateTime(first, second) {
  var mid = new Date((new Date(first).getTime() + new Date(second).getTime()) / 2);
  var pad = function pad(value) {
    return String(value).padStart(2, "0");
  };
  return "".concat(mid.getFullYear(), "-").concat(pad(mid.getMonth() + 1), "-").concat(pad(mid.getDate()), "T").concat(pad(mid.getHours()), ":").concat(pad(mid.getMinutes()));
}